import { render } from "./AccountBinding.vue?vue&type=template&id=24d5ae58"
import script from "./AccountBinding.vue?vue&type=script&lang=js"
export * from "./AccountBinding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__